import React, { useState, useEffect } from "react";
import { Input, Form, Select, Switch, Spin } from "antd";
import columns from "../../../columns/Rules.js";
import Pagination from "../../../components/global/pagination/Pagination.jsx";
import ConfirmationModal from "../../../components/global/modal/ConfirmationModal.jsx";
import TableWithSkeleton from "../../../components/global/table/TableWithSkeleton.jsx";
import moment from "moment";
import { GetAllRulesApi, UpdateUserStatusApi, UpdateRulesApi, GetrulesByIdApi } from "../../../api/request/settings/rules.js";
import toast from "react-hot-toast";
import Edit from "../../../assets/Edit.jsx";
import ModalComponent from "../../../components/global/modal/ModalComponent.jsx";
import LoadableButton from "../../../components/buttons/LoadableButton.jsx";
import Segmented from '../../../components/segmented/Segmented.jsx';

export default function Rules() {
  const defaultColumns = [
    { title: "Rule Name", dataIndex: "name" },
    { title: "Description", dataIndex: "description" },
    { title: "Rule Type", dataIndex: "ruleTypeName" },
    // { title: "Level", dataIndex: "ruleLevel" },
    { title: "Minimum", dataIndex: "min" },
    { title: "Maximum", dataIndex: "max" },
    { title: "Actions", dataIndex: "actions" },
  ];

  const accountColumns = [
    { title: "Rule Name", dataIndex: "name" },
    { title: "Description", dataIndex: "description" },
    { title: "Rule Type", dataIndex: "ruleTypeName" },
    // { title: "Level", dataIndex: "ruleLevel" },
    { title: "Demo Account", dataIndex: "demoAccount" },
    { title: "Live Account", dataIndex: "liveAccount" },
    { title: "Actions", dataIndex: "actions" },
  ];
  const [form] = Form.useForm();
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingData, setIsLoadingData] = useState(false);
  const [selectedRulesId, setSelectedRulesId] = useState("");
  const [isStatusConfirmOpen, setIsStatusConfirmOpen] = useState(false);
  const [isStatusConfirmLoading, setIsStatusConfirmLoading] = useState(false);
  const [rulesall, setrulesall] = useState()
  const [isEditTraderLoading, setIsEditTraderLoading] = useState(false);
  const [isOpenEditModal, setIsOpenEditModal] = useState(false);
  const [trader, setTrader] = useState({});
  const [initialValues, setInitialValues] = useState({ min: '', max: '', isLimit: null, isAuto: null });
  const [data, setData] = useState([]);
  const [value, setValue] = useState('Wallet');
  const [columns, setColumns] = useState(defaultColumns);

  useEffect(() => {
    if (value === "Account") {
      setColumns(accountColumns);
    } else {
      setColumns(defaultColumns);
    }
  }, [value]);

  // Function to get form fields based on segmented value
  const getFormFields = () => {
    switch (value) {
      case "Deposit":
      case "Withdraw":
      case "InternalTransfer":
      case "IBWalletWithdrawal":
      case "Wallet":
        return [
          { name: "min", label: "Minimum", type: "number" },
          { name: "max", label: "Maximum", type: "number" },
          { name: "isLimit", label: "Limit", type: "boolean" },
          { name: "isAuto", label: "Auto", type: "boolean" },
        ];
      case "KYC":
        return [
          { name: "isLimit", label: "Limit", type: "boolean" },
          { name: "isAuto", label: "Auto", type: "boolean" },
        ];
      case "Account":
        return [
          { name: "liveAccount", label: "Live Account", type: "number" },
          { name: "demoAccount", label: "Demo Account", type: "number" },
          { name: "isAuto", label: "Auto", type: "boolean" },
        ];
      default:
        return [];
    }
  };

  // Function to render form fields
  const renderFormFields = () => {
    const fields = getFormFields();
    return fields.map((field) => {
      if (field.type === "number") {
        return (
          <div className="input-white" key={field.name}>
            <label className="text-base text-[#2F2B3DCC] font-medium">
              {field.label}
            </label>
            <Form.Item name={field.name} rules={[{ required: true, message: `Please enter ${field.label.toLowerCase()}.` },]} >
              <Input type="number" placeholder={field.label} className="mt-1 w-full py-2" />
            </Form.Item>
          </div>
        );
      } else if (field.type === "boolean") {
        return (
          <div className="ant-select-selector-white" key={field.name}>
            <label className="text-base text-[#2F2B3DCC] font-medium">{field.label}</label>
            <Form.Item name={field.name} rules={[{ required: true, message: `Please select ${field.label}.` }]} >
              <Select placeholder={`Select ${field.label}`} className="w-full mt-1" options={[{ value: true, label: "Yes" }, { value: false, label: "No" },]} />
            </Form.Item>
          </div>
        );
      }
      return null;
    });
  };

  const handleEditSubmit = async (value) => {
    try {
      let apiParams = {
        ...value,
        ruleId: trader?.ruleId,
        ...(value.min && { min: parseInt(value.min) }),
        ...(value.max && { max: parseInt(value.max) }),
        ...(value.liveAccount && { liveAccount: parseInt(value.liveAccount) }),
        ...(value.demoAccount && { demoAccount: parseInt(value.demoAccount) }),
      };
      setIsEditTraderLoading(true);
      const { data } = await UpdateRulesApi(apiParams);
      if (data?.success) {
        toast.success(data?.message);
        setIsEditTraderLoading(false);
        setIsOpenEditModal(false);
        getAllRules();
      }
    } catch (error) {
      toast.error(error?.response?.data?.message);
      setIsEditTraderLoading(false);
    }
  };



  const getfAQFilters = (tag) => {
    switch (tag) {
      case 'Wallet':
        return 1;
      case 'KYC':
        return 2;
      case 'Deposit':
        return 3;
      case 'Withdraw':
        return 4;
      case 'Account':
        return 5;
      case 'InternalTransfer':
        return 6;
      case 'IBWalletWithdrawal':
        return 7;
      // case 'TerminalAccountWallet':
      //   return 8;
      // case 'WalletAccountTerminal':
      //   return 9;
      default:
        break;
    }
  }

  const getAllRules = async () => {
    try {
      setIsLoading(true);
      let params = {
        filterByRuleType: getfAQFilters(value)
      }
      const { data } = await GetAllRulesApi(new URLSearchParams(params).toString());
      if (data?.success) {
        setData(
          data?.data?.map((item) => {
            return {
              ...item,
              actions: (<button type="button" onClick={() => { setSelectedRulesId(item?.ruleId); setIsOpenEditModal(true); }}><Edit /></button>),
            };
          })
        );
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getAllRules();
  }, [value]);

  const statusHandler = async (params) => {
    setIsStatusConfirmOpen(true);
    setrulesall(params)
  }

  const statusChangeConfirm = async () => {
    try {
      setIsStatusConfirmLoading(true);
      const { data } = await UpdateUserStatusApi(rulesall);
      if (data?.success) {
        getAllRules();
        toast.success(data?.message);
      }

      setIsStatusConfirmLoading(false);
      setIsStatusConfirmOpen(false);
    } catch (error) {
      setIsStatusConfirmLoading(false);
    }
  }

  const handleFieldsChange = (_, allFields) => {
    const isChanged = allFields.some(field => field.touched);
  };

  const getRulesById = async () => {
    try {
      setIsLoadingData(true);
      const { data } = await GetrulesByIdApi(selectedRulesId);
      if (data?.success) {
        const values = {
          min: data?.data?.min,
          max: data?.data?.max,
          isLimit: data?.data?.isLimit,
          isAuto: data?.data?.isAuto,
          liveAccount: data?.data?.liveAccount,
          demoAccount: data?.data?.demoAccount
        };
        setInitialValues(values);
        form.setFieldsValue(values);
        setTrader(data?.data);
        setIsLoadingData(false);
      }
    } catch (error) {
      setIsLoadingData(false);
    }
  }

  useEffect(() => {
    if (selectedRulesId) {
      getRulesById();
    }
  }, [selectedRulesId]);


  return (
    <div>
      <div className="ant-select-selector-white mb-2">
        <Segmented options={['Wallet', 'KYC', 'Deposit', 'Withdraw', 'Account', 'InternalTransfer', 'IBWalletWithdrawal']} value={value} setValue={setValue} />
      </div>

      <div className="my-6">
        <div className="border border-gray-200 rounded-xl overflow-hidden bg-white">
          <TableWithSkeleton
            columns={columns}
            data={data}
            loading={isLoading}
          />
        </div>
        {/* <Pagination total={totalRecord} page={page} setPage={setPage} pageSize={pageSize} setPageSize={setPageSize} /> */}
      </div>

      <ConfirmationModal
        isOpen={isStatusConfirmOpen}
        setIsOpen={setIsStatusConfirmOpen}
        message='Are you sure to change the set Default rule?'
        onConfirm={statusChangeConfirm}
        isLoading={isStatusConfirmLoading}
        loadingLabel='Changing status...'
      />

      {/* Update user modal */}
      <ModalComponent isOpen={isOpenEditModal} setIsOpen={setIsOpenEditModal} title="Rules Update" width={1200}>
        {
          isLoadingData ? (
            <div className="flex justify-center flex-col my-[10%]">
              <Spin size="large" />
              <p className="primary text-center mt-2">Loading...</p>
            </div>
          ) : (
            <Form className="w-full" autoComplete="off" form={form} initialValues={initialValues} onFinish={handleEditSubmit} onFieldsChange={handleFieldsChange}>
              <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
                {renderFormFields()}
              </div>
              <div className="flex justify-end mt-8">
                <LoadableButton
                  className="bg-primary text-sm text-white font-semibold rounded-lg px-12 py-2 uppercase themeHover  duration-500"
                  type="Submit"
                  lable="Update"
                  isLoading={isEditTraderLoading}
                  loadingLable="Updating rules..."
                  disabled={isEditTraderLoading}
                />
              </div>
            </Form>
          )
        }
      </ModalComponent>
    </div>
  );
}
